namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_drafts_list, {
		width: 'min-content', flex: { basis: 'auto', grow: 0, shrink: 0 },
		Entry: {
			minWidth: 0, maxWidth: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere',
			'[selected]': { true: { color: $mol_theme.current, textShadow: '0 0' } },
		},
	})
}
